import { Alert, Button } from "@mui/material";
import { Component, ReactNode } from "react";

export class AuditErrorBoundary extends Component<
  {
    children: ReactNode;
    onRetry: () => void;
    onClearFilters?: () => void;
    fallback?: ReactNode;
    resetKey?: unknown;
    /** What could not be loaded; shown before the error's own message. */
    message?: string;
  },
  { error: Error | null; resetKey?: unknown }
> {
  state: { error: Error | null; resetKey?: unknown } = {
    error: null,
    resetKey: this.props.resetKey,
  };
  static getDerivedStateFromProps(props: { resetKey?: unknown }, state: { resetKey?: unknown }) {
    return props.resetKey !== state.resetKey ? { error: null, resetKey: props.resetKey } : null;
  }
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  render() {
    if (this.state.error && this.props.fallback !== undefined) return this.props.fallback;
    return this.state.error ? (
      <Alert
        severity="error"
        action={
          <>
            {this.props.onClearFilters && (
              <Button color="inherit" onClick={this.props.onClearFilters}>
                Clear filters
              </Button>
            )}
            <Button color="inherit" onClick={this.props.onRetry}>
              Retry
            </Button>
          </>
        }
      >
        {this.props.message ?? "Unable to load invoice audit."} {this.state.error.message}
      </Alert>
    ) : (
      this.props.children
    );
  }
}
